export interface User {
  fullName: string;
  isAdmin: boolean;
}

export enum TabName {
  "Overview" = "Overview",
  "Settlements" = "Settlements",
}

export enum SettlementsFilter {
  "DAYS_7" = 7,
  "DAYS_30" = 30,
  "YTD" = 365,
}

export enum SettlementStatus {
  "READY_FOR_SETTLEMENT_EXECUTION" = "READY_FOR_SETTLEMENT_EXECUTION",
  "ERROR_AT_SFI_HA_TO_SFI_CRYPTO_WALLET_TRX" = "ERROR_AT_SFI_HA_TO_SFI_CRYPTO_WALLET_TRX",
  "WAITING_FOR_SFI_HA_TO_SFI_CRYPTO_WALLET_TRX" = "WAITING_FOR_SFI_HA_TO_SFI_CRYPTO_WALLET_TRX",
  "ERROR_AT_SFI_HA_TO_SFI_FIAT_WALLET_TRX" = "ERROR_AT_SFI_HA_TO_SFI_FIAT_WALLET_TRX",
  "WAITING_FOR_SFI_HA_TO_SFI_FIAT_WALLET_TRX" = "WAITING_FOR_SFI_HA_TO_SFI_FIAT_WALLET_TRX",
  "ERROR_AT_SFI_FIAT_WALLET_TO_ALMOND_WALLET_TRX" = "ERROR_AT_SFI_FIAT_WALLET_TO_ALMOND_WALLET_TRX",
  "WAITING_FOR_SFI_FIAT_WALLET_TO_ALMOND_WALLET_TRX" = "WAITING_FOR_SFI_FIAT_WALLET_TO_ALMOND_WALLET_TRX",
  "ERROR_AT_SFI_FIAT_WALLET_TO_SFI_CRYPTO_WALLET_TRX" = "ERROR_AT_SFI_FIAT_WALLET_TO_SFI_CRYPTO_WALLET_TRX",
  "WAITING_FOR_SFI_FIAT_WALLET_TO_SFI_CRYPTO_WALLET_TRX" = "WAITING_FOR_SFI_FIAT_WALLET_TO_SFI_CRYPTO_WALLET_TRX",
  "ERROR_AT_SFI_CRYPTO_WALLET_TO_ALMOND_WALLET_TRX" = "ERROR_AT_SFI_CRYPTO_WALLET_TO_ALMOND_WALLET_TRX",
  "WAITING_FOR_SFI_CRYPTO_WALLET_TO_ALMOND_WALLET_TRX" = "WAITING_FOR_SFI_CRYPTO_WALLET_TO_ALMOND_WALLET_TRX",
  "ERROR_AT_SFI_CRYPTO_WALLET_TO_TFI_CRYPTO_WALLET_TRX" = "ERROR_AT_SFI_CRYPTO_WALLET_TO_TFI_CRYPTO_WALLET_TRX",
  "WAITING_FOR_SFI_CRYPTO_WALLET_TO_TFI_CRYPTO_WALLET_TRX" = "WAITING_FOR_SFI_CRYPTO_WALLET_TO_TFI_CRYPTO_WALLET_TRX",
  "ERROR_AT_TFI_CRYPTO_WALLET_TO_TFI_FIAT_WALLET_TRX" = "ERROR_AT_TFI_CRYPTO_WALLET_TO_TFI_FIAT_WALLET_TRX",
  "WAITING_FOR_TFI_CRYPTO_WALLET_TO_TFI_FIAT_WALLET_TRX" = "WAITING_FOR_TFI_CRYPTO_WALLET_TO_TFI_FIAT_WALLET_TRX",
  "ERROR_AT_TFI_FIAT_WALLET_TO_TFI_HA_TRX" = "ERROR_AT_TFI_FIAT_WALLET_TO_TFI_HA_TRX",
  "WAITING_FOR_TFI_FIAT_WALLET_TO_TFI_HA_TRX" = "WAITING_FOR_TFI_FIAT_WALLET_TO_TFI_HA_TRX",
  "ERROR_AT_TFI_CRYPTO_WALLET_TO_TFI_HA_TRX" = "ERROR_AT_TFI_CRYPTO_WALLET_TO_TFI_HA_TRX",
  "WAITING_FOR_TFI_CRYPTO_WALLET_TO_TFI_HA_TRX" = "WAITING_FOR_TFI_CRYPTO_WALLET_TO_TFI_HA_TRX",
  "SETTLEMENT_COMPLETED" = "SETTLEMENT_COMPLETED",
}

export interface Settlement {
  settlementId: string;
  initiatedAt: Date;
  completedAt: Date;
  status: SettlementStatus;
  sendAmt: number;
  receivedAmt: number;
  sourceCcy: string;
  targetFiatCcy: string;
  rate: number;
  almondFee: number;
  sourceFi: string;
  targetFi: string;
  settlementType: SettlementType;
  transferCryptoCcy: string;
  sourceCryptoExchange: string;
  targetCryptoExchange: string;
}

export const STATUS_OPTIONS = [
  {
    label: "Pending",
    value: "PENDING",
  },
  { label: "Completed", value: "SETTLEMENT_COMPLETED" },
];

enum SettlementType {
  AUTO,
  MANUAL,
}

export const SOURCE_FI_OPTIONS = [
  {
    label: "CHAS",
    value: "CHAS",
  },
  {
    label: "BSTN",
    value: "BSTN",
  },
];

export const TARGET_FI_OPTIONS = [
  {
    label: "ABAA",
    value: "ABAA",
  },
  {
    label: "PHTB",
    value: "PHTB",
  },
  {
    label: "MCT",
    value: "MCT",
  },
];

export const SOURCE_CRYPTO_EXCHANGE_OPTIONS = [
  {
    label: "Coinbase",
    value: "Coinbase",
  },
];
export const TARGET_CRYPTO_EXCHANGE_OPTIONS = [
  {
    label: "Bitkub",
    value: "Bitkub",
  },
];

export const SETTLEMENT_TYPE_OPTIONS = [
  {
    label: "Auto",
    value: "AUTO",
  },
  {
    label: "Manual",
    value: "MANUAL",
  },
];

export const TIME_FILTER_OPTIONS = [
  {
    label: "7 days",
    value: "DAYS_7",
  },
  {
    label: "30 days",
    value: "DAYS_30",
  },
  {
    label: "This year",
    value: "YTD",
  },
];

export interface RequestData {
  settlements: Settlement[];
  size: number;
  page: number;
}

export enum FilterVariants {
  Text,
  Select,
  Date,
}

export const TABLE_COLUMNS = {
  settlementId: {
    label: "ID",
    type: FilterVariants.Text,
  },
  completedAt: {
    label: "Completed At",
    type: FilterVariants.Date,
  },
  sendAmt: {
    label: "Send Amount",
    type: FilterVariants.Text,
  },
  sourceCcy: {
    label: "Source Currency",
    type: FilterVariants.Text,
  },
  rate: {
    label: "Rate",
    type: FilterVariants.Text,
  },
  receivedAmt: {
    label: "Received Amount",
    type: FilterVariants.Text,
  },
  targetFiatCcy: {
    label: "Target Fiat Currency",
    type: FilterVariants.Text,
  },
  status: {
    label: "Status",
    type: FilterVariants.Select,
  },
  initiatedAt: {
    label: "Initiated At",
    type: FilterVariants.Date,
  },
  settlementType: {
    label: "Settlement Type",
    type: FilterVariants.Text,
  },
  almondFee: {
    label: "Almond Fee",
    type: FilterVariants.Text,
  },
  sourceFi: {
    label: "Source FI",
    type: FilterVariants.Text,
  },
  transferCryptoCcy: {
    label: "Transfer Crypto",
    type: FilterVariants.Text,
  },
  targetFi: {
    label: "Target FI",
    type: FilterVariants.Text,
  },
  sourceCryptoExchange: {
    label: "Source Crypto Exchange",
    type: FilterVariants.Text,
  },
  targetCryptoExchange: {
    label: "Target Crypto Exchange",
    type: FilterVariants.Text,
  },
};
